// 処理をSleepする ※awaitをつけて呼び出すこと
export const sleep = second => new Promise(r => setTimeout(r, second * 1000));
